import * as React from 'react';



export default class AddIcon extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g fill="none" fillRule="evenodd">
            <rect width="16" height="16" fill="#05B6A9" rx="2"/>
            <path fill="#FFF" d="M8.88 8.77v4.902H7.61V8.77H3.118V7.499h4.49V2.731H8.88v4.768h4.492v1.272z"/>
        </g>
      </svg>  
    )
  }
}
